var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatLoveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82837 0.9H25.1716C27.8934 0.9 30.1 3.10655 30.1 5.82837V14C30.1 16.7218 27.8935 18.9284 25.1716 18.9284H16.9958C16.6822 18.9284 16.3817 19.0577 16.166 19.2871C16.1659 19.2872 16.1658 19.2873 16.1657 19.2874L9.7435 26.1159V20.0675C9.7435 19.4384 9.23353 18.9284 8.60439 18.9284H5.82837C3.10654 18.9284 0.9 16.7219 0.9 14V5.82837C0.9 3.10654 3.10644 0.9 5.82837 0.9Z",
    stroke: "url(#paint0_linear)",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3479 6.69292C18.4784 5.76903 17.0688 5.76903 16.1993 6.69292L15.7081 7.21481C15.591 7.33924 15.4011 7.33924 15.284 7.21481L14.8007 6.70126C13.9313 5.77736 12.5216 5.77736 11.6521 6.70126C10.7826 7.62516 10.7826 9.1231 11.6521 10.047L15.2843 13.9067C15.4014 14.0311 15.5913 14.0311 15.7084 13.9067L19.3479 10.0387C20.2174 9.11477 20.2174 7.61686 19.3479 6.69292Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 12.989,
    y1: 4.82311,
    x2: 22.3736,
    y2: 25.4856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF794D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 14.771,
    y1: 7.42148,
    x2: 17.5642,
    y2: 13.4795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF794D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatLoveIcon);
export default __webpack_public_path__ + "static/media/chat-love-icon.143164b5c6e85a09c0f96347eae3e849.svg";
export { ForwardRef as ReactComponent };